import { render, staticRenderFns } from "./couponActivity.vue?vue&type=template&id=9c029cf0&"
import script from "./couponActivity.vue?vue&type=script&lang=js&"
export * from "./couponActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports